import { CUSTOM_PROVIDERS_PART01 } from './customProviders.part01.js'
import { CUSTOM_PROVIDERS_PART02 } from './customProviders.part02.js'
import { CUSTOM_PROVIDERS_PART03 } from './customProviders.part03.js'

/**
 * Providers the Custom model dialog offers. `keyPattern` checks the shape of a
 * key locally — nothing is sent anywhere — and a provider with a
 * `baseUrlPlaceholder` also needs an endpoint URL.
 */
export const CUSTOM_PROVIDERS = [...CUSTOM_PROVIDERS_PART01, ...CUSTOM_PROVIDERS_PART02, ...CUSTOM_PROVIDERS_PART03]

export const findCustomProvider = (id) => CUSTOM_PROVIDERS.find((provider) => provider.id === id) ?? null

/** A model's display name, or the id itself when the user typed their own. */
export function customModelLabel(providerId, modelId) {
  return findCustomProvider(providerId)?.models.find((model) => model.id === modelId)?.label ?? modelId
}
